var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');

var ltNetwork = Object.create(Model);
  
ltNetwork.name = 'Lontalk Network';
ltNetwork.url = 'lontalknetwork';
ltNetwork['@class'] = 'LontalkNetwork';
ltNetwork.actions = [
  {
    name: 'Discover',
    func: function (ctrl) {
      return loaders.requestWithLoader({
        url: ctrl.record['@id'] + '/sync/',
        method: "GET",
        loader: 'submit'
      })
      .then(function (res) {
        return ctrl.init();
      })
      .catch(function (e) {
        alert(JSON.stringify(e.response.cause));
      })
    }
  }
];

ltNetwork.fields = {
  parent: {
    hidden: true
  },
  name: {
    type: 'string',
    default: '',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  eesPath: {
    type: 'string',
    validators: {}
  },
  lastSync: {
    type: 'string',
    validators: {}
  },
};

ltNetwork.initForm();

ltNetwork.view = function () { 
  return  m('form', {role:'form'}, [
    ltNetwork.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltNetwork.form.name(ev.target.value)},
        value: ltNetwork.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eespath-input'}, 'EES Path'),
      m('input.form-control', {
        id:'eespath-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltNetwork.form.eesPath(ev.target.value)},
        value: ltNetwork.form.eesPath(),
      })
    ])
  ])
}

module.exports = ltNetwork;
